import * as React from "react";
import Grid from "@mui/material/Grid";
import { CmpStatusIcon, CmpTypographyField } from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Typography } from "@mui/material";
export const DispatchSummaryTblCard = ({ data = [], onClick = () => {} }) => {
  let xsLabel = 2.2;
  let xsColon = 0.1;
  let xsValue = 3.7;

  let mdLabel = 3;
  let mdColon = 0.5;
  let mdValue = 8.5;
  return (
     
    <Grid container spacing={1} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid item xs={12} sm={6} md={6} key={index} onClick={() => {
                  let items = { row: item };
                  onClick(items);
                }}>
          <div className="easy-putaway-card">
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
              
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Voc No
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.VocNo}
                </Typography>
              </Grid>
              
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Post Date
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {moment(item.PostDate).format('MM/DD/YYYY')}
                </Typography>
              </Grid>

             
              
              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                Status
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {/* {item.Status} */}
                  <CmpStatusIcon xStatus={item?.Status}/>
                </Typography>

              </Grid>
              
              <Grid item xs={12} md={12}>
              <Typography variant="body1" className="value">
                  {item.PartyName}
                </Typography>
              </Grid>
              {/* {item.PartyName  &&<Grid item xs={12} md={12} style={{display:item?.PartyName == ""? 'none':''}}  >
                <Typography variant="body1" className="value">
                {item.PartyName}
                </Typography>
              </Grid>} */}
                 
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
